export default __webpack_public_path__ + "static/slide-1-ad650ce318816a512e1331b3c50e248a.jpg";